export default __webpack_public_path__ + "static/upper4_3-833b911cf2c923305d333907645849e3.jpg";